import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Greet from "../components/greet"

const IndexPage = () => {
  return (
    <Layout>
      <SEO title="Home" />
      <div className="content">
        <Greet />
      </div>
    </Layout>
  )
}

export default IndexPage
